import Clickable from '/components/Clickable';
import PropTypes from 'prop-types';
import Typography from '/components/Typography';
import classNames from '/utils/class-names';

const PrintTypes = ({ productFilters = {}, selectedProductConfig, updateProductFilters }) => {
	if (!selectedProductConfig?.productType?.printTypes) {
		return false;
	}

	return (
		<div className="flex flex-wrap gap-2 justify-center">
			{selectedProductConfig.productType.printTypes.map((printType, printTypeIndex) => {
				return (
					<div
						className="flex items-center align-middle justify-center gap-2 mt-2 m-x-auto"
						key={printTypeIndex}>
						<Clickable
							className={classNames(
								'rounded-full border-gray-600 border-2 py-1 px-4 md:px-12',
								productFilters.printType === printType.key
									? 'bg-gray-600 text-white'
									: 'hover:bg-gray-200',
							)}
							onClick={() => updateProductFilters('printType', printType.key)}>
							<Typography variant="subtitle-sm">{printType.label}</Typography>
						</Clickable>
					</div>
				);
			})}
		</div>
	);
};

PrintTypes.propTypes = {
	productFilters: PropTypes.object,
	selectedProductConfig: PropTypes.object,
	updateProductFilters: PropTypes.func,
};

export default PrintTypes;
